import React, { Component } from "react";
import { Link } from "react-router-dom";
import throttle from "lodash/throttle";

import tracking from "../../../utils/tracking";
import {
  HEADER_COPY,
  BODY_COPY,
  COLOUR,
  IMAGE_NAME,
  TAGS
} from "../../../utils/content-keys";

import Card from "../../Card";
import images from "./images";
import "./beer-card.scss";
import lazyLoad from "../../../utils/lazy-load";

class BeerCard extends Component {
  state = { render: false };
  cardRef = null;
  throttledScroll = null;

  componentDidMount() {
    this.throttledScroll = throttle(
      () =>
        lazyLoad(this.cardRef, window.innerHeight + 50, this.scrollCallback),
      200
    );
    window.addEventListener("scroll", this.throttledScroll);

    lazyLoad(this.cardRef, window.innerHeight + 50, this.scrollCallback);
  }

  scrollCallback = () => {
    if (this.cardRef.src) {
      return;
    }

    this.cardRef.src = this.cardRef.getAttribute("data-src");
    this.cardRef.setAttribute("data-src", "");

    this.setState({ render: true });
    window.removeEventListener("scroll", this.throttledScroll);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledScroll);
  }

  render() {
    const { className, beer, large, routeProps, filter } = this.props;
    return (
      <div className={`beer-card ${large ? "beer-card--lg" : ""}`}>
        {!large ? (
          <Link
            className={`${className}-link`}
            to={`/the-beers/${beer.Header[0][HEADER_COPY].value
              .trim()
              .toLowerCase()
              .replace(/\s/g, "-")}`}
            onClick={() =>
              tracking.event("customEvent", {
                eventCategory: "Beer card",
                eventAction: "click",
                eventLabel: `${beer.Header[0][HEADER_COPY].value}, source: ${
                  routeProps.location.pathname
                }${filter ? `, filter: ${filter}` : ""}`
              })
            }
          >
            <Card className={className} bgColor={beer.Header[0][COLOUR].value}>
              <h3 className="beer-card__title">
                <span className="beer-card__title-underline">
                  {beer.Header[0][HEADER_COPY].value}
                </span>
              </h3>
              <img
                className="beer-panel__image"
                data-src={beer.Header[0][IMAGE_NAME].imgURL}
                alt=""
                key={`beer-card_${beer.Header[0][HEADER_COPY].value}`}
                ref={el => {
                  if (!this.cardRef && el) {
                    this.cardRef = el;
                  }
                }}
              />
              {beer.Tags[0][TAGS].value && (
                <p className="beer-card__description">
                  <img
                    className="beer-card__description--icon"
                    alt=""
                    src={
                      images[
                        beer.Tags[0][TAGS].value
                          .replace(/[^a-zA-Z\s]/g, "")
                          .replace(/\s/g, "_")
                          .toLowerCase()
                      ]
                    }
                  />
                  {beer.Tags[0][TAGS].value}
                </p>
              )}
            </Card>
          </Link>
        ) : (
          <Card className={className} bgColor={beer.Header[0][COLOUR].value}>
            <div className="row no-gutters">
              <div className="col-3 beer-card__left-col">
                <img
                  className="beer-panel__image"
                  data-src={beer.Header[0][IMAGE_NAME].imgURL}
                  alt=""
                  ref={el => {
                    if (!this.cardRef && el) {
                      this.cardRef = el;
                    }
                  }}
                />
              </div>
              <div className="col-9 beer-card__right-col">
                <h3 className="beer-card__title">
                  {beer.Header[0][HEADER_COPY].value}
                </h3>
                {beer.Characteristics.map((char, index) => (
                  <div
                    className="beer-card__char-container"
                    key={`char_${index}_${beer.Header[0][HEADER_COPY].value}`}
                  >
                    <p className="beer-card__prop beer-card__prop--title">
                      {char[HEADER_COPY].value}
                    </p>
                    <p className="beer-card__prop beer-card__prop--value">
                      {char[BODY_COPY].value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        )}
      </div>
    );
  }
}

export default BeerCard;



// WEBPACK FOOTER //
// ./src/components/_common/BeerCard/index.js